import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { AuthModel } from "../../services/models";
import { useAuth } from "../../context/AuthContext";
import { Loader } from '../common';
import ProtectedLayout from "../../layouts/ProtectedLayout";

export default function ProtectedLayoutRoute() {
  const { isLoggedIn, toggleLogin } = useAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // If already logged in and have token, skip verification (e.g., just logged in)
    const token = AuthModel.getToken();
    if (isLoggedIn && token) {
      setLoading(false);
      return;
    }

    const checkTokenValidity = async () => {
      try {
        // Ensure token exists before making request
        const currentToken = AuthModel.getToken();
        if (!currentToken) {
          throw new Error('No token found');
        }

        const result = await AuthModel.verifyToken();
        if (result && result.status === 200) {
          toggleLogin(true);
        } else {
          throw new Error('Invalid token');
        }
      } catch (error) {
        AuthModel.logout();
        toggleLogin(false);
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      checkTokenValidity();
    } else {
      AuthModel.logout();
      toggleLogin(false);
      setLoading(false);
    }
  }, [isLoggedIn, toggleLogin]);

  if (loading) {
    return <Loader />;
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return <ProtectedLayout />;
}

